import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { useTranslation } from 'react-i18next';

import LogoImage from '@/assets/images/logo.png';
import { IdentityProvider } from '@/lib/api';
import { useAuth } from '@/lib/hooks';

import { AvatarMenu } from './AvatarMenu';
import { DebugControls } from './DebugControls';

interface Props {
    onMenuClick?: () => void;
    menuOpen?: boolean;
    showMenu?: boolean;
    onTanstackToggle?: () => void;
    tanstackOpen?: boolean;
}

export const Nav = ({
    menuOpen,
    onMenuClick,
    showMenu: showMenuProp = true,
    onTanstackToggle,
    tanstackOpen,
}: Props) => {
    const { t } = useTranslation();
    const { authed, termsAccepted, user } = useAuth();
    const showMenu = showMenuProp && authed && termsAccepted && user?.identity_provider !== IdentityProvider.proxy;

    return (
        <AppBar position="fixed" sx={{ paddingTop: 1, paddingBottom: 1 }}>
            <Toolbar variant="dense">
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <Stack direction="row" spacing={1}>
                        {showMenu && (
                            <IconButton edge="start" aria-label="menu" onClick={onMenuClick} sx={{ color: '#fff' }}>
                                {menuOpen ? <MenuOpenIcon /> : <MenuIcon />}
                            </IconButton>
                        )}
                        <img src={LogoImage} alt={t('nav.logo-alt-text', 'Outgrow Your Garage logo')}></img>
                    </Stack>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <DebugControls onTanstackToggle={onTanstackToggle} tanstackOpen={tanstackOpen} />
                        {showMenu && <AvatarMenu />}
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};
